// 配置本地测试
module.exports = {
    // 接口地址配置
    baseURL: 'https://api.getapi.run/',
    docsURL: 'https://docs.getapi.run/',
    mockURL: 'https://mock.getapi.run/',
    webURL: 'https://web.getapi.run/',
    officialURL: 'https://getapi.run/',
}
